import { c as _c } from "react/compiler-runtime";
import type { KeyboardLike, KeyWith } from '@/lib/piano/keyboard';
import { useGenerateSerie } from './use-generate-serie';
import { useMemo } from 'react';
import type { TouchDesignSerie } from '../interfaces';
import { TouchDesignSerieVariant } from '../KeyboardChart';
export const useDefaultSerie = (keyboard, seriesNames, seriesWithBoldVariant, seriesMap) => {
  const $ = _c(9);
  const {
    generateSerie
  } = useGenerateSerie(keyboard);
  let t0;
  if ($[0] !== generateSerie || $[1] !== seriesMap || $[2] !== seriesNames || $[3] !== seriesWithBoldVariant) {
    let t1;
    if ($[5] !== generateSerie || $[6] !== seriesMap || $[7] !== seriesWithBoldVariant) {
      t1 = serieName => {
        const variant = seriesWithBoldVariant.includes(serieName) ? TouchDesignSerieVariant.DefaultBold : TouchDesignSerieVariant.Default;
        return generateSerie(key => seriesMap[serieName]?.[key.number - 1] ?? null, `${serieName}`, variant);
      };
      $[5] = generateSerie;
      $[6] = seriesMap;
      $[7] = seriesWithBoldVariant;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    t0 = seriesNames.map(t1);
    $[0] = generateSerie;
    $[1] = seriesMap;
    $[2] = seriesNames;
    $[3] = seriesWithBoldVariant;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const defaultSeries = t0;
  return defaultSeries;
};